import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pricePipe',
})
export class PricePipe implements PipeTransform {
  transform(value: number, denomination?: string, changedValue?: boolean, decimals: number = 2): any {
    if (changedValue !== true) {
      if (value == -1) {
        return 'Undisclosed';
      } else if (value == -2) {
        return 'N/A';
      } else if (value == 0) {
        return 'Nil';
      }
    }

    const currencySymbol = '₹';
    let negative = false;

    if (value < 0) {
      negative = true;
      value = Math.abs(value);
    }

    return this.formatLargeValue(value, negative, currencySymbol, decimals);
  }

  // Helper function to format values with decimals and large units
  private formatLargeValue(value: number, negative: boolean, currencySymbol: string, decimals: number): string {
    if (value === null || isNaN(value)) return '';

    let formattedValue = '';

    // Check value range and apply Indian number system for Lakh and Crore
    if (value >= 10000000) {
      // Value is in Crores
      const croreValue = (value / 10000000).toFixed(decimals);
      formattedValue = this.formatWithIndianCommas(Number(croreValue)) + ' Cr';
    } else if (value >= 100000) {
      // Value is in Lacs
      const lakhValue = (value / 100000).toFixed(decimals);
      formattedValue = this.formatWithIndianCommas(Number(lakhValue)) + ' Lakh';
    } else {
      // Values below 1 Lakh, format normally
      formattedValue = this.formatWithIndianCommas(value.toFixed(decimals));
    }

    // Handle negative values and return formatted result
    return negative ? `-${currencySymbol}${formattedValue}` : `${currencySymbol}${formattedValue}`;
  }

  // Helper function to format a number with Indian number system commas
  private formatWithIndianCommas(value: number | string): string {
    const valueString = value.toString();

    // Split into integer and decimal parts
    let [integerPart, decimalPart] = valueString.split('.');

    // Apply Indian comma formatting for the integer part
    let lastThreeDigits = integerPart.slice(-3);
    let otherDigits = integerPart.slice(0, -3);

    if (otherDigits !== '') {
      lastThreeDigits = ',' + lastThreeDigits;
    }

    // Format the remaining digits in pairs of two, starting from the right
    const formattedInteger = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

    // Combine integer and decimal parts, if there is a decimal part
    return decimalPart ? formattedInteger + lastThreeDigits + '.' + decimalPart : formattedInteger + lastThreeDigits;
  }
}
